exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#courier-modal-portal {\n  position: absolute;\n  z-index: 1500;\n}\n\n#courier-modal-map-container {\n  height: 50vh;\n}\n@media only screen and (max-width: 599px) {\n  #courier-modal-map-container {\n    height: 300px;\n  }\n}\n\n#courier-modal-portal .react-modal-body {\n  width: 550px;\n}\n@media only screen and (max-width: 599px) {\n  #courier-modal-portal .react-modal-body {\n    width: 80%;\n  }\n}", ""]);

// exports
